// extracted by mini-css-extract-plugin
export default {"btnJoin":"BtnJoin_btnJoin__0at4n"};